import React from 'react'
import { change as changeFieldValue, Field, formValueSelector, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import Select from 'react-select';
import $ from 'jquery';
import {
  apenasNumero,
  apenasLetra,
  renderField, renderFieldCpf, renderFieldTelefone, validarCPF, minTamanhoNome, maxTamanhoNome,
  requiredSelect,
  required
} from '../../util/inputs';
import recuperarPessoaPorCpfCnpj from '../../actions/pessoa/recuperarPessoaPorCpfCnpj';
import adicionarDadosComprador from '../../actions/viagem/adicionarDadosComprador';
import { paisesDDI } from '../../util/constantsUtil';

export const validate = (values) => {
  const errors = {};
  if (!values.nome) {
    errors.nome = 'Campo obrigatório'
  }
  if (!values.cpf) {
    errors.cpf = 'Campo obrigatório'
  }
  if (!values.telefone) {
    errors.telefone = 'Campo obrigatório'
  }

  return errors
};

export class DadosComprador extends React.Component {
  constructor (props) {
    super(props);
    this.limparFormulario = this.limparFormulario.bind(this);
    this.submit = this.submit.bind(this);
    this.state = {
      mensagem: { tipo: '', texto: '' },
      arquivo: null
    };
  }

  submit (values) {    
    const comprador = {
      cpfComprador: values.cpf,
      nomeComprador: values.nome,
      telefoneComprador: values.telefone,
      ddiComprador: values.ddiComprador.value ? Number(values.ddiComprador.value) : 32,
    }
    this.props.adicionarDadosComprador(comprador);
    this.fecharModal()
  }

  fecharModal () {
    $('#modalCadastrarDadosComprador')
      .modal('hide');
    $('#modalCadastrarDadosComprador')
      .hide();
    $('.modal-backdrop')
      .hide();
    this.props.reset('formularioCadastrarDadosComprador')
  }

  exibirComboDDI(event) {    
      return (
          <div>
              <Select
                  {...event.input}                  
                  options={paisesDDI.map(elemento => ({
                    label: `${elemento.pais} ${elemento.ddi}`,
                    value: elemento.id
                  }))}
                  onChange={(value) => {
                    this.clearTelefone()
                    event.input.onChange(value);                    
                  }}
              />
              {event.meta.touched
              && (event.meta.error && <span style={{color: 'red'}}>{event.meta.error}</span>)}
        </div>
      )    
  }

  clearTelefone() {
    this.props.changeFieldValue('formularioCadastrarDadosComprador', 'telefone', '');
  }

  alterarAba (aba) {
    this.setState({ tabAtiva: aba })
  }

  ativarAba (aba) {
    if (aba === this.state.tabAtiva) {
      return 'nav-link active'
    }
    return 'nav-link'
  }

  limparMensagem () {
    this.setState({ mensagem: undefined })
  }

  limparFormulario () {
    this.props.reset('formularioCadastrarDadosComprador');
    this.limparMensagem();
  }

  buscarUsuarioPorCpf (cpf) {
    if(apenasNumero(cpf).length === 11){
      this.props.recuperarPessoaPorCpfCnpj(apenasNumero(cpf)).then((resp) => {
        if (resp.payload.data !== '' && resp.payload.status === 200) {
          this.props.changeFieldValue('formularioCadastrarDadosComprador', 'nome', resp.payload.data.nome);
          this.props.changeFieldValue('formularioCadastrarDadosComprador', 'telefone', resp.payload.data.telefone);
        }
      })
    }
  }

  render () {
    const {
      handleSubmit, submitting, invalid, pristine
    } = this.props;

    return (
      <div className="modal fade show" role="dialog"
           id="modalCadastrarDadosComprador" aria-labelledby="modalCadastrarDadosComprador"
           aria-hidden="true" data-backdrop="static">
        <div className="modal-dialog modal-info modal-md modal-dialog-centered">
          <div className="modal-content vx-modal-content">
            <div className="vx-modal-header">
              <div className="vx-modal-header-left">
                <i className="material-icons">account_circle</i>
                <span className="vx-modal-title">Dados do comprador</span>
              </div>
              <button type="button" className="vx-modal-close" data-dismiss="modal"
                      id="btnFecharModalCadastrarDadosComprador"
                      onClick={() => this.limparFormulario()} aria-label="Close">
                <i className="material-icons">close</i>
              </button>
            </div>
            <form onSubmit={handleSubmit(this.submit)}>
              <div className="vx-modal-body">
                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <i className="material-icons">badge</i> Identificação
                  </div>
                  <div className="form-group mb-2">
                    <Field name="cpf" type="text" component={renderFieldCpf}
                           label="Número CPF comprador:"
                           validate={[validarCPF]}
                           css="form-control" readOnly={false}
                           onBlur={e => this.buscarUsuarioPorCpf(e.target.value)}/>
                  </div>
                  <div className="form-group mb-0">
                    <Field name="nome" type="text" component={renderField}
                           label="Nome completo:"
                           validate={[apenasLetra, minTamanhoNome, maxTamanhoNome]}
                           css="form-control" readOnly={false}/>
                  </div>
                </div>
                <div className="vx-modal-section">
                  <div className="vx-modal-section-title">
                    <i className="material-icons">phone</i> Contato
                  </div>
                  <div className="form-group mb-2">
                    <label>Código do País</label>
                    <Field name='ddiComprador'
                           validate={requiredSelect}
                           component={this.exibirComboDDI.bind(this)}
                           css="form-control"/>
                  </div>
                  <div className="form-group mb-0">
                    {this.props.ddiComprador && this.props.ddiComprador.value === 32
                      ? <Field name="telefone" type="text" component={renderFieldTelefone}
                               css="form-control" label="Telefone"/>
                      : <Field name="telefone" type="text" max={15} component={renderField}
                               validate={[required]}
                               css="form-control" label="Telefone"/>}
                  </div>
                </div>
              </div>
              <div className="vx-modal-footer">
                <button type="button" className="vx-btn-modal-cancel" data-dismiss="modal"
                        onClick={() => this.limparFormulario()}>Cancelar</button>
                <button type="submit" disabled={invalid || submitting || pristine}
                        className="vx-btn-modal-save">
                  <i className="material-icons">check</i>Salvar
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    )
  }
}

export function mapStateToProps (state) {
  return {
    dadosPagamento: state.dadosPagamento,
    ddiComprador: formValueSelector('formularioCadastrarDadosComprador')(state, 'ddiComprador')    
  }
}

export default connect(mapStateToProps,
  {
    adicionarDadosComprador, recuperarPessoaPorCpfCnpj, changeFieldValue
  })(reduxForm({
  form: 'formularioCadastrarDadosComprador',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(DadosComprador));
